import { v4 as uuid4 } from 'uuid'
export class Category {
    constructor(json = {}){
        this.id = json.id || uuid4()
        this.pk_category = json.pk_category || null
        this.name = json.name || ''
    }
}